import { render } from "./RequireAlert.vue?vue&type=template&id=0028d158&ts=true"
import script from "./RequireAlert.vue?vue&type=script&lang=ts"
export * from "./RequireAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__